export function unregisterOldServiceWorkers() {
  if ('serviceWorker' in navigator) {
    // eslint-disable-next-line no-console
    console.log('[SW UTILS]: check for old service workers');
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        if (!registration.active) continue;
        if (
          !registration.scope.includes('/pwa') &&
          !registration.active.scriptURL.includes('dev-sw') &&
          registration.active.scriptURL.includes('sw.js')
        ) {
          // eslint-disable-next-line no-console
          console.log('[SW UTILS]: old service worker detected', registration);
          registration.unregister();
        }
      }
    });
  }
}
